import React, { useState, useEffect } from 'react';

const SignContract = () => {
  const [contract, setContract] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [signatureName, setSignatureName] = useState('');
  const [agreed, setAgreed] = useState(false);
  const [signing, setSigning] = useState(false);
  const [signed, setSigned] = useState(false);

  // Get contract ID from URL
  const contractId = new URLSearchParams(window.location.search).get('id');

  useEffect(() => {
    if (!contractId) {
      setError('Invalid contract link');
      setLoading(false);
      return;
    }
fetch(`https://api.hermespartnercapital.co/api/contract/${contractId}`)
      .then(r => r.json())
      .then(data => {
        if (data.success) {
          setContract(data.contract);
        } else {
          setError('Contract not found');
        }
        setLoading(false);
      })
      .catch(() => {
        setError('Failed to load contract');
        setLoading(false);
      });
  }, [contractId]);

  const handleSign = async () => {
    if (!signatureName.trim()) {
      alert('Please type your full name to sign');
      return;
    }
    if (!agreed) {
      alert('Please confirm you have read and agree to the terms');
      return;
    }

    setSigning(true);
    try {
const response = await fetch('https://api.hermespartnercapital.co/api/sign-contract', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          contractId,
          signatureName: signatureName.trim(),
          ipAddress: 'client-ip'
        })
      });

      const data = await response.json();
      if (data.success) {
        setSigned(true);
      } else {
        throw new Error(data.error);
      }
    } catch (err) {
      alert(`Signing failed: ${err.message}`);
    }
    setSigning(false);
  };

  // ── Loading ──
  if (loading) return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', backgroundColor: '#f0ebe3' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '40px', marginBottom: '20px' }}>⏳</div>
        <p style={{ fontSize: '18px', color: '#666' }}>Loading your agreement...</p>
      </div>
    </div>
  );

  // ── Error ──
  if (error) return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', backgroundColor: '#f0ebe3' }}>
      <div style={{ textAlign: 'center', backgroundColor: 'white', padding: '40px', borderRadius: '12px' }}>
        <div style={{ fontSize: '40px', marginBottom: '20px' }}>❌</div>
        <h2 style={{ color: '#dc3545' }}>Contract Not Found</h2>
        <p style={{ color: '#666' }}>{error}</p>
        <p style={{ color: '#666' }}>Please contact us at info@hermespartnercapital.com</p>
      </div>
    </div>
  );

  // ── Already Signed ──
  if (signed) return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', backgroundColor: '#f0ebe3' }}>
      <div style={{ textAlign: 'center', backgroundColor: 'white', padding: '50px', borderRadius: '12px', maxWidth: '500px' }}>
        <div style={{ fontSize: '60px', marginBottom: '20px' }}>🎉</div>
        <h2 style={{ color: '#28a745', marginBottom: '15px' }}>Agreement Signed!</h2>
        <p style={{ fontSize: '18px', color: '#333', marginBottom: '10px' }}>
          Welcome to Hermes Partner Capital!
        </p>
        <p style={{ color: '#666', marginBottom: '25px' }}>
          You'll receive a confirmation copy at your email shortly. Our team will be in touch within 1 business day to get you set up.
        </p>
        <div style={{ backgroundColor: '#f8f9fa', padding: '15px', borderRadius: '8px' }}>
          <p style={{ margin: '0 0 5px 0', fontSize: '14px', color: '#666' }}>Questions?</p>
          <p style={{ margin: 0, fontWeight: 'bold' }}>info@hermespartnercapital.com</p>
          <p style={{ margin: 0, fontWeight: 'bold' }}>(224) 475-9646</p>
        </div>
      </div>
    </div>
  );

  const { prospectInfo, agreementDate } = contract;

  // ── Contract View ──
  return (
   <div style={{ backgroundColor: '#f0ebe3', minHeight: '100vh', padding: '20px 16px', overflowX: 'hidden', fontFamily: 'Arial, sans-serif' }}>
      <div style={{ maxWidth: '800px', margin: '0 auto' }}>

        {/* Header */}
        <div style={{ backgroundColor: '#6B1A1A', padding: '30px', borderRadius: '12px 12px 0 0', textAlign: 'center' }}>
          <h1 style={{ color: 'white', margin: '0 0 5px 0' }}>Hermes Partner Capital</h1>
          <p style={{ color: '#f0e0e0', margin: 0, fontStyle: 'italic' }}>Fortune Favors the Bold</p>
        </div>

        {/* Contract Body */}
        <div style={{ backgroundColor: 'white', padding: '40px' }}>
          <h2 style={{ textAlign: 'center', marginBottom: '30px', color: '#333' }}>AI Virtual Front Desk Service Agreement</h2>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '20px', marginBottom: '30px', backgroundColor: '#f8f9fa', padding: '20px', borderRadius: '8px' }}>
            <div>
              <p style={{ margin: '0 0 8px 0' }}><strong>Agreement Date:</strong> {agreementDate}</p>
              <p style={{ margin: '0 0 8px 0' }}><strong>Contract ID:</strong> {contractId}</p>
              <p style={{ margin: 0 }}><strong>Service Provider:</strong> Hermes Partner Capital</p>
            </div>
            <div>
              <p style={{ margin: '0 0 8px 0' }}><strong>Client:</strong> {prospectInfo.businessName}</p>
              <p style={{ margin: '0 0 8px 0' }}><strong>Contact:</strong> {prospectInfo.primaryContact}</p>
              <p style={{ margin: 0 }}><strong>Email:</strong> {prospectInfo.email}</p>
            </div>
          </div>

          {/* Fee Summary */}
          <div style={{ backgroundColor: '#6B1A1A', color: 'white', padding: '20px', borderRadius: '8px', marginBottom: '30px', textAlign: 'center' }}>
            <h3 style={{ margin: '0 0 15px 0' }}>Investment Summary</h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '20px' }}>
              <div style={{ backgroundColor: 'rgba(255,255,255,0.1)', padding: '15px', borderRadius: '6px' }}>
                <p style={{ margin: '0 0 5px 0', fontSize: '13px', opacity: 0.8 }}>One-Time Setup Fee</p>
                <p style={{ margin: 0, fontSize: '28px', fontWeight: 'bold' }}>$500</p>
              </div>
              <div style={{ backgroundColor: 'rgba(255,255,255,0.1)', padding: '15px', borderRadius: '6px' }}>
                <p style={{ margin: '0 0 5px 0', fontSize: '13px', opacity: 0.8 }}>Monthly Retainer</p>
<p style={{ margin: 0, fontSize: '28px', fontWeight: 'bold' }}>$350</p>
              </div>
            </div>
          </div>

          {/* Contract Sections */}
          {[
            {
              title: '1. Services Provided',
              content: `Hermes Partner Capital agrees to provide the AI Virtual Front Desk service. This service includes a 24/7 AI-powered call answering system trained on the Client's business, configured to answer inbound calls, qualify leads, book appointments, send SMS alerts to the Client, and automate follow-up sequences.`
            },
            {
              title: '2. Fees & Payment Terms',
content: `Setup Fee: $500 (one-time, due upon signing). Monthly Fee: $350/month, billed on the same date each month via credit card or ACH on file. First monthly payment is due one month after signing. Service is suspended after 5 days past due. Reinstatement fee of $150 applies if service is suspended and later reinstated. All fees are non-refundable once the billing period has begun.`
            },
            {
              title: '3. Term & Termination',
              content: `This Agreement begins on the date signed and continues month-to-month. Either party may terminate with 30 days written notice via email. Upon termination, the AI system will be deactivated at the end of the final paid billing period. All call recordings and lead data will be available to Client for 14 days post-termination, after which they will be deleted. No partial-month refunds will be issued.`
            },
            {
              title: '4. Client Responsibilities',
              content: `The Client agrees to: provide accurate business information during onboarding; notify Hermes Partner Capital of any changes within 5 business days; forward the designated phone number to the AI system as instructed; respond to qualified leads in a timely manner. Hermes Partner Capital is not responsible for lost jobs due to Client non-response.`
            },
            {
              title: '5. Performance & Limitations',
              content: `Hermes Partner Capital will make commercially reasonable efforts to maintain 99% uptime. The AI system performs based on information provided during onboarding. The AI does not replace the Client's judgment — final decisions on quoting, scheduling, and job acceptance remain with the Client. Hermes Partner Capital is not liable for lost revenue resulting from system outages or caller behavior. Call volume is not guaranteed.`
            },
            {
              title: '6. Confidentiality',
              content: `Both parties agree to keep confidential any proprietary information shared in the course of this Agreement. Call recordings and lead data collected by the AI system are the property of the Client. Hermes Partner Capital will not share, sell, or use this data for any purpose other than operating and improving the service for the Client.`
            },
            {
              title: '7. Intellectual Property',
              content: `The AI system, its configuration, prompt architecture, and workflow logic remain the sole intellectual property of Hermes Partner Capital. The Client receives a limited, non-transferable license to use the system for the duration of this Agreement.`
            },
            {
              title: '8. Limitation of Liability',
              content: `Hermes Partner Capital's total liability shall not exceed the total fees paid in the 30 days preceding the event giving rise to the claim. Hermes Partner Capital is not liable for indirect, incidental, or consequential damages of any kind.`
            },
            {
              title: '9. Governing Law',
              content: `This Agreement is governed by the laws of the State of Illinois. Disputes shall be resolved in the courts of Cook County, Illinois, or through binding arbitration if both parties agree.`
            },
          ].map((section, i) => (
            <div key={i} style={{ marginBottom: '25px' }}>
              <h4 style={{ color: '#6B1A1A', marginBottom: '10px', borderBottom: '1px solid #eee', paddingBottom: '8px' }}>{section.title}</h4>
              <p style={{ color: '#444', lineHeight: '1.7', margin: 0 }}>{section.content}</p>
            </div>
          ))}

          {/* Signature Block */}
          <div style={{ backgroundColor: '#f8f9fa', padding: '30px', borderRadius: '12px', marginTop: '30px', border: '2px solid #6B1A1A' }}>
            <h3 style={{ color: '#6B1A1A', marginBottom: '20px', textAlign: 'center' }}>✍️ Electronic Signature</h3>
            <p style={{ color: '#666', fontSize: '14px', marginBottom: '20px', textAlign: 'center' }}>
              By typing your full legal name and clicking "I Agree & Sign", you acknowledge that you have read, understood, and agree to all terms of this Agreement. This electronic signature is legally binding under the ESIGN Act.
            </p>

            {/* Hermes Signature */}
            <div style={{ marginBottom: '25px', padding: '15px', backgroundColor: 'white', borderRadius: '8px' }}>
              <p style={{ margin: '0 0 5px 0', fontWeight: 'bold' }}>Hermes Partner Capital</p>
             <p style={{ margin: '0 0 5px 0', fontFamily: 'cursive', fontSize: '22px', color: '#6B1A1A' }}>{contract.rep === 'Matthew Moskvitin' ? 'Matthew Moskvitin' : 'Randy Lepe'}</p>
<p style={{ margin: 0, fontSize: '13px', color: '#666' }}>{contract.rep === 'Matthew Moskvitin' ? 'Matthew Moskvitin' : 'Randy Lepe'} — Partner | {agreementDate}</p>
            </div>

            {/* Client Signature */}
            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
                Your Full Legal Name (acts as your signature) *
              </label>
              <input
                type="text"
                placeholder={`e.g. ${prospectInfo.primaryContact}`}
                value={signatureName}
                onChange={e => setSignatureName(e.target.value)}
                style={{ padding: '15px', border: '2px solid #6B1A1A', borderRadius: '8px', fontSize: '18px', width: '100%', boxSizing: 'border-box', fontFamily: 'cursive' }}
              />
            </div>

            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', marginBottom: '25px' }}>
              <input type="checkbox" id="agree" checked={agreed} onChange={e => setAgreed(e.target.checked)}
                style={{ marginTop: '3px', width: '18px', height: '18px', cursor: 'pointer' }} />
              <label htmlFor="agree" style={{ cursor: 'pointer', color: '#333', lineHeight: '1.5' }}>
                I confirm that I have read and agree to all terms and conditions of this Service Agreement. I understand this is a legally binding electronic signature.
              </label>
            </div>

            <button
              onClick={handleSign}
              disabled={signing || !signatureName.trim() || !agreed}
              style={{
                width: '100%',
                padding: '18px',
                backgroundColor: signing || !signatureName.trim() || !agreed ? '#ccc' : '#28a745',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '18px',
                fontWeight: 'bold',
                cursor: signing || !signatureName.trim() || !agreed ? 'not-allowed' : 'pointer',
                transition: 'background 0.2s'
              }}
            >
              {signing ? '⏳ Signing...' : '✅ I Agree & Sign'}
            </button>

            <p style={{ textAlign: 'center', fontSize: '12px', color: '#999', marginTop: '15px' }}>
              🔒 Secured by Hermes Partner Capital | Contract ID: {contractId}
            </p>
          </div>
        </div>

        {/* Footer */}
        <div style={{ backgroundColor: '#6B1A1A', padding: '20px', borderRadius: '0 0 12px 12px', textAlign: 'center' }}>
          <p style={{ color: '#f0e0e0', margin: 0, fontSize: '13px' }}>
            Hermes Partner Capital | Chicagoland, Illinois | info@hermespartnercapital.com
          </p>
        </div>
      </div>
    </div>
  );
};

export default SignContract;